import intro01 from "./Introduccion/Intro-01.mp3";
import intro02 from "./Introduccion/Intro-02.mp3";

import sub1a01 from "./Subtema-1/T9-Sub 1-Act 1-A01.mp3";
import sub1a02 from "./Subtema-1/T9-Sub 1-Act 1-A02.mp3";
import sub1a03 from "./Subtema-1/T9-Sub 1-Act 1-A03.mp3";
import sub1a04 from "./Subtema-1/T9-Sub 1-Act 1-A04.mp3";
import sub2a01 from "./Subtema-1/T9-Sub 1-Act 2-A01.mp3";
import sub2a02 from "./Subtema-1/T9-Sub 1-Act 2-A02.mp3";
import sub2a03 from "./Subtema-1/T9-Sub 1-Act 2-A03.mp3";
import sub2a04 from "./Subtema-1/T9-Sub 1-Act 2-A04.mp3";
import sub2a05 from "./Subtema-1/T9-Sub 1-Act 2-A05.mp3";
import sub2a06 from "./Subtema-1/T9-Sub 1-Act 2-A06.mp3";
import sub3a01 from "./Subtema-1/T9-Sub 1-Act 3-A01.mp3";
import sub3a02 from "./Subtema-1/T9-Sub 1-Act 3-A02.mp3";
import sub3a03 from "./Subtema-1/T9-Sub 1-Act 3-A03.mp3";
import sub3a04 from "./Subtema-1/T9-Sub 1-Act 3-A04.mp3";
import sub3a05 from "./Subtema-1/T9-Sub 1-Act 3-A05.mp3";
import sub3a06 from "./Subtema-1/T9-Sub 1-Act 3-A06.mp3";
import sub3a07 from "./Subtema-1/T9-Sub 1-Act 3-A07.mp3";
import sub3a08 from "./Subtema-1/T9-Sub 1-Act 3-A08.mp3";
import sub4a01 from "./Subtema-1/T9-Sub 1-Act 4-A01.mp3";


import fin01 from "./Fin/Final-01.mp3";
import fin02 from "./Fin/Final-02.mp3";


export const T9_voices = {
	introduccion: {
		intro01,
		intro02,
	},
	subtema1: {
		sub1a01,
		sub1a02,
		sub1a03,
		sub1a04,
		sub2a01,
		sub2a02,
		sub2a03,
		sub2a04,
		sub2a05,
		sub2a06,
		sub3a01,
		sub3a02,
		sub3a03,
		sub3a04,
		sub3a05,
		sub3a06,
		sub3a07,
		sub3a08,
		sub4a01,
	},
	fin: {
		fin01,
		fin02,
	},
};
